var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-one-quarter has-borders-column",class:{
    'has-background-info-light':
        _vm.sorting == _vm.sortingOptions.lowestMinimumInstallment,
}},[_c('span',{staticClass:"heading-inline"},[_vm._v("wpłata minimalna")]),_c('br'),_c('small',[_vm._v(_vm._s(_vm.broker.minInstallment))])])}
var staticRenderFns = []

export { render, staticRenderFns }